<template>
  <div class="workbench-editor">
    <Toolbar :editor="editor" :defaultConfig="toolbarConfig" mode="default" class="editor-toolbar" />
    <Editor :value="value" :defaultConfig="editorConfig" mode="default" class="editor-body"
      @onCreated="createdEditor" @onChange="changedEditor" @customPaste="customPaste" />
    <div class="editor-hint">{{ uploading ? '文件上传中，请稍候…' : '正文最多15000字；图片10MB内，MP4视频单文件20GB内；正文和附件合计最多20个文件。' }}<el-button v-if="uploading" type="text" size="mini" @click="cancelUploads">取消上传</el-button></div>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { uploadWorkbenchMedia, imageExtensions, maxContentFileBytes } from './workbenchUpload'

export default {
  name: 'WorkbenchRichEditor',
  components: { Editor, Toolbar },
  props: { value: { type: String, default: '' }, mediaCount: { type: Number, default: 0 } },
  data() {
    return {
      editor: null, pending: 0, disposed: false, uploadControllers: [],
      toolbarConfig: { toolbarKeys: ['headerSelect', 'bold', 'italic', 'underline', 'through', 'color', 'bgColor', 'fontSize', '|',
        'bulletedList', 'numberedList', 'justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'delIndent', '|',
        'insertLink', 'uploadImage', 'uploadVideo', 'insertTable', 'blockquote', 'clearStyle', 'undo', 'redo', 'fullScreen'] },
      editorConfig: {
        placeholder: '输入正文，可在光标位置插入图片或视频', maxLength: 15000,
        MENU_CONF: {
          uploadImage: { maxFileSize: 10 * 1048576, customUpload: (file, insert) => this.upload(file, insert, imageExtensions) },
          uploadVideo: { maxFileSize: maxContentFileBytes, customUpload: (file, insert) => this.upload(file, insert, ['mp4']) }
        }
      }
    }
  },
  computed: { uploading() { return this.pending > 0 } },
  beforeDestroy() { this.disposed = true; this.cancelUploads(); if (this.editor) this.editor.destroy() },
  methods: {
    cancelUploads() { this.uploadControllers.forEach(controller => controller.abort()) },
    createdEditor(editor) { this.editor = Object.seal(editor) },
    changedEditor(editor) { this.$emit('input', editor.getHtml()) },
    customPaste(editor, event, callback) {
      const clipboard = event.clipboardData
      // Files use the editor's upload path. External HTML images must not bypass OSS.
      if (clipboard && !clipboard.files.length && clipboard.getData('text/html').match(/<(img|video|source|iframe)\b/i)) {
        editor.insertText(clipboard.getData('text/plain'))
        this.$message.warning('已粘贴文字；图片和视频请通过上传按钮添加')
        event.preventDefault(); callback(false); return
      }
      callback(true)
    },
    async upload(file, insert, allowed) {
      if (this.mediaCount + this.pending >= 20) { this.$message.warning('正文和附件合计最多20个文件'); return }
      this.pending++; this.$emit('uploading', true)
      const controller = new AbortController(); this.uploadControllers.push(controller)
      try {
        const media = await uploadWorkbenchMedia(this.axios, file, allowed, () => {}, '', { signal: controller.signal })
        if (this.disposed) return
        this.$emit('uploaded', { ...media, inline: true })
        if (media.kind === 'IMAGE') insert(media.url, media.name, '')
        else insert(media.url, '')
      } catch (error) { if (!this.disposed) this.$message[error.cancelled ? 'info' : 'error'](error.message || '上传失败') }
      finally { this.uploadControllers = this.uploadControllers.filter(item => item !== controller); this.pending--; if (!this.disposed) this.$emit('uploading', this.uploading) }
    }
  }
}
</script>

<style scoped>
.workbench-editor{border:1px solid #dcdfe6;line-height:normal;position:relative;z-index:1}.editor-toolbar{border-bottom:1px solid #dcdfe6}.editor-body{height:360px;overflow-y:hidden}.editor-hint{padding:10px;color:#909399;font-size:12px;border-top:1px solid #ebeef5;line-height:1.5}.workbench-editor /deep/ .w-e-full-screen-container{z-index:4000}
</style>
